// extracted by css-extract-rspack-plugin
export default {"stats":"ewXV9x","stat":"GTah7Y"};